import React, { useState } from 'react';
import logo from '../../src/img/wetrnd.png';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Smooth scroll function
  const handleScrollTo = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const navbarHeight = 100;
      const elementPosition = element.offsetTop - navbarHeight;

      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
    setIsMenuOpen(false);
  };

  // WhatsApp handler
  const handleWhatsApp = () => {
    window.open('https://wa.me/919004901184', '_blank', 'noopener,noreferrer');
    setIsMenuOpen(false);
  };

  return (
    <>
      {/* Desktop & Mobile Navbar */}
      <nav className="fixed top-4 left-1/2 transform -translate-x-1/2 w-auto bg-white shadow-lg z-50 px-12 py-4 rounded-2xl min-w-fit max-md:px-6 max-md:py-3 max-md:w-[90%]">
        <div className="flex justify-between items-center gap-8">
          {/* Logo */}
          <div className="flex items-center">
            <img
              src={logo}
              alt="WETREND Logo"
              className="h-[70px] w-auto rounded-xl object-contain max-md:h-[50px]"
            />
          </div>

          {/* Desktop Navigation Links */}
          <div className="hidden md:flex items-center space-x-10">
            <button
              onClick={() => handleScrollTo('services')}
              className="text-gray-700 hover:text-gray-900 font-medium transition-colors duration-200 cursor-pointer"
            >
              Services
            </button>
            <button
              onClick={() => handleScrollTo('whyus')}
              className="text-gray-700 hover:text-gray-900 font-medium transition-colors duration-200 cursor-pointer"
            >
              Why WETREND?
            </button>
            <button
              onClick={() => handleScrollTo('faqs')}
              className="text-gray-700 hover:text-gray-900 font-medium transition-colors duration-200 cursor-pointer"
            >
              FAQs
            </button>

            {/* Desktop Chat Now Button */}
            <button
              onClick={handleWhatsApp}
              className="bg-gray-800 hover:bg-gray-900 text-white px-8 py-2 rounded-lg font-medium transition-colors duration-200 ml-6 whitespace-nowrap"
            >
              Chat Now
            </button>
          </div>

          {/* Mobile Hamburger Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-gray-700 hover:text-gray-900 focus:outline-none z-50"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>
        </div>
      </nav>

      {/* Full-Screen Mobile Menu Overlay */}
      <div
        className={`fixed inset-0 bg-white z-[60] transition-transform duration-300 ease-in-out md:hidden ${
          isMenuOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        {/* Menu Header */}
        <div className="flex justify-between items-center p-6 border-b border-gray-200">
          <img
            src={logo}
            alt="WETREND Logo"
            className="h-[60px] w-auto rounded-lg object-contain"
          />
          <button
            onClick={() => setIsMenuOpen(false)}
            className="text-gray-700 hover:text-gray-900 focus:outline-none"
          >
            <svg
              className="w-8 h-8"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Menu Items Container */}
        <div className="flex flex-col h-[calc(100%-140px)] justify-between">
          {/* Navigation Links */}
          <div className="flex flex-col px-6 py-8 space-y-1">
            <button
              onClick={() => handleScrollTo('services')}
              className="text-gray-800 hover:text-gray-900 font-medium text-lg text-left py-4 border-b border-gray-100"
            >
              Services
            </button>
            <button
              onClick={() => handleScrollTo('whyus')}
              className="text-gray-800 hover:text-gray-900 font-medium text-lg text-left py-4 border-b border-gray-100"
            >
              Why WETREND?
            </button>
            <button
              onClick={() => handleScrollTo('faqs')}
              className="text-gray-800 hover:text-gray-900 font-medium text-lg text-left py-4 border-b border-gray-100"
            >
              FAQs
            </button>
          </div>

          {/* Chat Now Button - Fixed at Bottom */}
          <div className="p-6 border-t border-gray-200">
            <button
              onClick={handleWhatsApp}
              className="w-full bg-gray-800 hover:bg-gray-900 text-white px-6 py-4 rounded-lg font-semibold text-lg transition-colors duration-200"
            >
              Chat Now
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;